import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'scripts/react-components/themes/Theme'

type StyleProps = {
  color: string
}
const baseStyles = ({ theme }: Theme) => css`
  label: share-button;

  button svg {
    label: share-button__icon;

    color: ${theme.colors.n600};
  }
`
const iconWrapperStyles = ({ color }: StyleProps) => css`
  label: icon-wrapper;

  svg {
    fill: ${color};
    width: 35px;
    height: 35px;
  }
`

export const ShareButton = styled('span')(baseStyles)
export const IconWrapper = styled('div')(iconWrapperStyles)
